import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    pure: false,
    standalone: false
})
export class TruncatePipe implements PipeTransform {

  transform(text: string, length: number = 25, suffix: string = '...'): string {

    if (text && text?.length > length) {
      let truncated: string = text.substring(0, length).trim() + suffix;
      return truncated;
    }

    return text;
  }
}